import React from 'react';
import {
  Border,
  Bottom,
  BottomThird,
  Center,
  Circle,
  Description,
  First,
  Footer,
  Left,
  LeftDiv,
  Main,
  Middle,
  MiddleThird,
  Right,
  RightDiv,
  Third,
  Top,
  TopBorder,
  TopThird
} from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { ICON_SIZE } from '../../../global/constants';

interface Props {
  isMessagesLoading?: boolean;
  isWidth?: boolean;
  isProjectMessageDetail?: boolean;
}
export default function MessageLoading(Props: Props) {
  return (
    <Main isMessagesLoading={Props.isMessagesLoading} isProjectMessageDetail={Props.isProjectMessageDetail}>
      <Border isMessagesLoading={Props.isMessagesLoading}>
        <TopBorder />
        <Center className='loading-animation' />
        <TopBorder />
      </Border>
      <Description isMessagesLoading={Props.isMessagesLoading}>
        <First>
          <Circle isMessagesLoading={Props.isMessagesLoading}>
            <Left isMessagesLoading={Props.isMessagesLoading} className='loading-animation'></Left>
          </Circle>
          <Right isMessagesLoading={Props.isMessagesLoading}>
            <Top className='loading-animation'></Top>
            <Bottom isMessagesLoading={Props.isMessagesLoading} className='loading-animation'></Bottom>
          </Right>
        </First>
        <First>
          <Circle isMessagesLoading={Props.isMessagesLoading}>
            <Left isMessagesLoading={Props.isMessagesLoading} className='loading-animation'></Left>
          </Circle>
          <Right isWidth={Props.isWidth}>
            <Top className='loading-animation'></Top>
            <Middle isMessagesLoading={Props.isMessagesLoading} className='loading-animation'></Middle>
            <Bottom isWidth={Props.isWidth} className='loading-animation'></Bottom>
          </Right>
        </First>
        <Third>
          <Circle isMessagesLoading={Props.isMessagesLoading}>
            <Left isMessagesLoading={Props.isMessagesLoading} className='loading-animation'></Left>
          </Circle>
          <Right isWidth={true}>
            <TopThird className='loading-animation'></TopThird>
            <MiddleThird isMessagesLoading={Props.isMessagesLoading} className='loading-animation'></MiddleThird>
            <BottomThird isMessagesLoading={Props.isMessagesLoading} className='loading-animation'></BottomThird>
          </Right>
        </Third>
      </Description>
      <Border isMessagesLoading={Props.isMessagesLoading}>
        <TopBorder />
        <Center className='loading-animation' />
        <TopBorder />
      </Border>
      <Description isMessagesLoading={Props.isMessagesLoading}>
        <First>
          <Circle isMessagesLoading={Props.isMessagesLoading}>
            <Left isMessagesLoading={Props.isMessagesLoading} className='loading-animation'></Left>
          </Circle>
          <Right isMessagesLoading={Props.isMessagesLoading}>
            <Top className='loading-animation'></Top>
            <Bottom isMessagesLoading={Props.isMessagesLoading} className='loading-animation'></Bottom>
          </Right>
        </First>
        <First>
          <Circle isMessagesLoading={Props.isMessagesLoading}>
            <Left isMessagesLoading={Props.isMessagesLoading} className='loading-animation'></Left>
          </Circle>
          <Right isWidth={Props.isWidth}>
            <Top className='loading-animation'></Top>
            <Bottom isMessagesLoading={Props.isMessagesLoading} className='loading-animation'></Bottom>
            {Props.isMessagesLoading && <Bottom isWidth={Props.isWidth} className='loading-animation'></Bottom>}
          </Right>
        </First>
      </Description>
      <Footer isProjectMessageDetail={Props.isProjectMessageDetail}>
        <LeftDiv className='loading-animation'></LeftDiv>
        <RightDiv>
          <SVGIcon
            name='updated-emoji-icon'
            width={ICON_SIZE.XL}
            height={ICON_SIZE.XL}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            className='svg'
          />
          <SVGIcon
            name='file-attachment-icon'
            width={ICON_SIZE.XL}
            height={ICON_SIZE.XL}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            className='svg'
          />
          <SVGIcon
            name='send-icon'
            width={ICON_SIZE.XL}
            height={ICON_SIZE.XL}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            className='svg'
          />
        </RightDiv>
      </Footer>
    </Main>
  );
}
